import { DeleteRounded, ExpandMore, CheckCircle, PriorityHighRounded } from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Box, Button, Dialog, DialogActions, DialogContent, Grid,
	IconButton, Tooltip, Typography} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import { useMutation, useQuery } from "@tanstack/react-query";
import React, { SyntheticEvent, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Controller, useForm, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {useRecoilState, useRecoilValue} from "recoil";
import _ from "underscore";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { FormAutocomplete, FormDatePicker, FormTextField } from "../../../common/form-fields-wrappers";
import { GENDER_LIST, ITALY_CODE, BILLING_OWNER_TYPE } from "../../../config";
import { DRIVER_LICENCE_CATEGORY_LIST } from "../../../data";
import { ICustomer, ICustomerData, ICustomerDataForm, IGetCustomersParams } from "../../../models/models";
import { fetchProvincesByCountryCode, getCommonPlaces } from "../../services/http.services";
import {
	customerDataAccordionState, driverResidenceCountriesListState, prefixesListState, bookingDataValueFamilyState,
	bookingDataValueState, customerDataValueState, createRaPricingInfoState,
	recoveryRaModeState,
	recoveryRaInfoState
} from "../../state";
import {ADDITIONAL_DRIVER_INIT_VALUE, DriverCheckLabel, INIT_DRIVER_FIELDS_STATE} from "../config";
import SearchCustomerDialog from "../../search-customer-dialog/SearchCustomerDialog";
import GoogleAutocompleteWrapper from "../../../../../util/component/GoogleAutocompleteWrapper";
import {deepCloneValue, fillDriverResponse, fillPersonResponse, genericValidate, getDataFromApiGoogle} from "../../../utils";
import DrivingLicenseIssuingPlaceField from "./partials/DrivingLicenseIssuingPlaceField";
import DrivingLicenseIssuingProvinceField from "./partials/DrivingLicenseIssuingProvinceField";
import IdIssuingPlaceField from "./partials/IdIssuingPlaceField";
import IdIssuingProvinceField from "./partials/IdIssuingProvinceField";
import UploadDocument from "./partials/UploadDocument";
import HeaderDriverData from "./partials/HeaderDriverData";
import { IDriverData } from "./types";
import { CUSTOMER_STATES } from "../../config";
import InputAdornment from "@mui/material/InputAdornment";
import { CustomerSearchFilters } from "../../../types";
import { findCustomerBaseByUniqueData } from "../../../check-out-in/services/http.services";
import CustomLoader from "../../../../../util/component/CustomLoader";
import {deepClone} from "../../../../../util/state/commonFunctions";
import dayjs from "dayjs";

const DriverData = ({ind, title, referenceProp, immutableRa, deleteAdditionalDriver, validateDocuments, keyLess}: IDriverData) => {
	const { t } = useTranslation(['network', 'translation']);

	const { dispatchGlobalData } = useContext(GlobalContext);
	const curReferenceProp = referenceProp + (ind !== undefined ? '[' + ind + ']' : '');
	const driverKey = ind === undefined ? 'mainDriver' : 'addDrivers';
	const [driverAccordions, setDriverAccordion]: any = useRecoilState(customerDataAccordionState(driverKey));
	const accordionState = ind === undefined ? driverAccordions : driverAccordions[ind];

	const [openDelDialog, setOpenDelDialog] = useState<boolean>(false);
	const [source, setSource] = useState<string>('');
	const [newAdded, setNewAdded] = useState<boolean>(false);
	const prefixesList = useRecoilValue(prefixesListState);
	const countriesList = useRecoilValue(driverResidenceCountriesListState);
	const bookingDataValue = useRecoilValue(bookingDataValueState);
	const bookingDataValueFamily = useRecoilValue(bookingDataValueFamilyState(source));
	const customerDataForm: any = useFormContext<ICustomerDataForm>();

	const [cfValidated, setCfValidated] = useState<string | null | undefined>(undefined);
	const [birthPlace, setBirthPlace] = useState<any>(undefined);
	const [residencePlace, setResidencePlace] = useState<any>(undefined);
	const [birthNationDisable, setBirthNationDisable] = useState<boolean>(true);
	const [initDriverFieldsState, setInitDriverFieldsState] = useState(INIT_DRIVER_FIELDS_STATE);

	const [customerDataValue, setCustomerDataValue] = useRecoilState(customerDataValueState);
	const createRaPricingInfo = useRecoilValue(createRaPricingInfoState);

	const recoveryMode = useRecoilValue(recoveryRaModeState);
	const recoveryRaInfo = useRecoilValue(recoveryRaInfoState);

	const [openValidateDocumentsDialog, setOpenValidateDocumentsDialog] = useState<boolean>(false);

	const googleInputPropsBirthField = {
		onPlaceSelected: (place: any) => selectedBirthCountry(place),
		options: {fields: ['address_components']}
	}

	const googleInputPropsResidenceField = {
		onPlaceSelected: (place: any) => selectedResidenceAddress(place),
		options: {fields: ['address_components'], types: ['address']}
	}

	const [residenceCountry, cbId, uuid, idDocFront, idDocBack, drivingLicenseDocFront, drivingLicenseDocBack, verifiedDocuments] = useWatch({
		name: [
			`${curReferenceProp}.residenceCountry`,
			`${curReferenceProp}.cbId`,
			`${curReferenceProp}.uuid`,
			`${curReferenceProp}.idDocFront`,
			`${curReferenceProp}.idDocBack`,
			`${curReferenceProp}.drivingLicenseDocFront`,
			`${curReferenceProp}.drivingLicenseDocBack`,
			`${curReferenceProp}.verifiedDocuments`
		]
	});

// 	const {defaultValues} = customerDataForm.formState;
// console.log('DF: ', defaultValues);
	const handleAccordionOnChange = (e: React.SyntheticEvent, expanded: boolean) => {
		e.stopPropagation();
		if (ind === undefined) {
			setDriverAccordion(expanded);
		} else {
			const accs = driverAccordions.concat();
			accs[ind] = expanded;
			setDriverAccordion(accs);
		}
	}

	const handleResidenceCountryChange = () => {
		customerDataForm.setValue(`${curReferenceProp}.residenceProvince`, null);
	}

	const [searchDialogOpen, setSearchDialogOpen] = useState<boolean>(false);
	const [customersFilter, setCustomersFilter] = useState<IGetCustomersParams['filters']>(null);
	const [customerFinded, setCustomerFinded] = useState<ICustomer[] | undefined>(undefined);

	const handleCloseSearchDialog = () => {
		setSearchDialogOpen(false);
		setCustomerFinded(undefined);
	}

	const handleClickSearch = (e: SyntheticEvent) => {
		e.stopPropagation();
		const {fiscalCode, drivingLicenseNumber, email, name, surname} = customerDataForm.getValues(curReferenceProp);
		if (!fiscalCode && !drivingLicenseNumber && !email && !name && !surname) {
			dispatchGlobalData({
				type: setSnackbar,
				payload: {
					snackbar: {
						message: t('customerData.message.error.searchCustomers'),
						type: snackbarTypes.error,
						show: true,
						autoClose: true,
					},
				},
			});
			return;
		}
		setCustomerFinded(undefined);
		setCustomersFilter({firstName: name, lastName: surname, fiscalCode, drivingLicenseNumber, email});
		setSearchDialogOpen(true);
	}

	const handleClickClear = (e: SyntheticEvent) => {
		e.stopPropagation();
		setCfValidated(undefined);
		customerDataForm.setValue(curReferenceProp, ADDITIONAL_DRIVER_INIT_VALUE);
		checkDataIsEditable(null);

		resetCheckExistenceParamsOld();
	}

	// const resetFormDefaultDriverData = (type: string, driver: ICustomerData) => {
	// 	const a = deepClone(customerDataForm.formState.defaultValue);
	// 	a.mainDriver.name = 'AAA';
	// 		customerDataForm.reset(a);
	// 	// for (const [key, value] of Object.entries(driver)) {
	// 	// 	const value1 = deepClone(value);
	// 	// 	console.log(`${type}.${key}:`, value);
	// 	// 	customerDataForm.resetField(`${type}.${key}`, {defaultValue: value1});
	// 	// }
	// }

	const setDriverData = (type: string, driver: ICustomerData) => {
		for (const [key, value] of Object.entries(driver)) {
			customerDataForm.setValue(`${type}.${key}`, value);
		}
    }

	const handleClickReload = (e: SyntheticEvent) => {
		e.stopPropagation();

		const dD = fillPersonResponse(bookingDataValueFamily);

		setDriverData(ind === undefined ? 'mainDriver' : `additionalDrivers[${ind}]`, dD);
		setCfValidated(bookingDataValueFamily?.cfValidated || null);
		customerDataForm.setValue(`${curReferenceProp}.addressGoogleSearch`, ADDITIONAL_DRIVER_INIT_VALUE.addressGoogleSearch);
		checkDataIsEditable(dD);

		resetCheckExistenceParamsOld();
	}

	const handleCustomerSelected = (customer: ICustomer) => {
		if (driverKey === 'mainDriver' && customer?.state === CUSTOMER_STATES.SUSPENDED) {
			dispatchGlobalData({
				type: setSnackbar,
				payload: {
					snackbar: {
						message: t('customerData.message.error.suspended'),
						type: snackbarTypes.error,
						show: true,
						autoClose: true,
					}
				}
			});
			return;
		}

		const customerData = fillDriverResponse(deepClone(customer));

		// /** resetField */
		// resetFormDefaultDriverData(ind === undefined ? 'mainDriver' : `additionalDrivers[${ind}]`, customerData);

		setDriverData(curReferenceProp, customerData);
		customerDataForm.setValue(`${curReferenceProp}.addressGoogleSearch`, ADDITIONAL_DRIVER_INIT_VALUE.addressGoogleSearch);

		checkDataIsEditable(customerData);

		const cdv = deepCloneValue(customerDataValue);
		if (ind === undefined) {
			cdv.mainDriver = customerData;
		} else {
			cdv.additionalDrivers[ind] = customerData;
		}
		setCustomerDataValue(cdv);
		setCfValidated(customer?.cfValidated);
	}

	const handleChangeIdIssueDate = () => {
		customerDataForm.setValue(`${curReferenceProp}.idIssuingPlace`, null);
	}

	const handleChangeDrivingLicenseIssueDate = () => {
		customerDataForm.setValue(`${curReferenceProp}.issuingPlace`, null);
	}

	const provincesQuery = useQuery({
		queryKey: ['ntw_provinces', residenceCountry],
		queryFn: () => {
			if (!residenceCountry) {return null}
			return fetchProvincesByCountryCode({code: residenceCountry.code});
		},
		enabled: !!residenceCountry
	});

	const commonPlacesQuery = useQuery({
		queryKey: ['ntw_common_places'],
		queryFn: getCommonPlaces
	});

	const selectedResidenceAddress = useCallback((result : any) => {setResidencePlace(result)}, [])

	const selectedBirthCountry = useCallback((result : any) => {setBirthPlace(result)}, []);

	/** reset value residence address data **/
	const handleResetResidenceAddressFields = useCallback(() => {
			customerDataForm.setValue(`${curReferenceProp}.addressGoogleSearch`, ADDITIONAL_DRIVER_INIT_VALUE.addressGoogleSearch);
			customerDataForm.setValue(`${curReferenceProp}.residenceCountry`, ADDITIONAL_DRIVER_INIT_VALUE.residenceCountry);
			customerDataForm.setValue(`${curReferenceProp}.residenceCity`, ADDITIONAL_DRIVER_INIT_VALUE.residenceCity);
			customerDataForm.setValue(`${curReferenceProp}.address`, ADDITIONAL_DRIVER_INIT_VALUE.address);
			customerDataForm.setValue(`${curReferenceProp}.streetNumber`, ADDITIONAL_DRIVER_INIT_VALUE.streetNumber);
			customerDataForm.setValue(`${curReferenceProp}.postcode`, ADDITIONAL_DRIVER_INIT_VALUE.postcode);
			customerDataForm.setValue(`${curReferenceProp}.residenceProvince`, ADDITIONAL_DRIVER_INIT_VALUE.residenceProvince);
			customerDataForm.setValue(`${curReferenceProp}.citizenship`, ADDITIONAL_DRIVER_INIT_VALUE.citizenship);
	}, []);

	/** reset value birth address data **/
	const handleResetBirthFields = useCallback(() => {
		customerDataForm.setValue(`${curReferenceProp}.birthPlace`, ADDITIONAL_DRIVER_INIT_VALUE.birthPlace);
		customerDataForm.setValue(`${curReferenceProp}.birthNation`, {code: ADDITIONAL_DRIVER_INIT_VALUE.birthNation});
		setBirthNationDisable(true);
	}, [])

	const EndAdornemnt = useMemo(() => {
		if (typeof cfValidated === 'undefined') {
			return undefined;
		}
		return (
			<InputAdornment position="start">
				{!!cfValidated ? <CheckCircle color="success" /> : <PriorityHighRounded color="error" />}
			</InputAdornment>
		)
	}, [cfValidated]);

	const handleDeleteAdditionalDriver = (e: React.SyntheticEvent) => {
		e.stopPropagation();

		if (deleteAdditionalDriver)
			setOpenDelDialog(true);
	}

	const deleteDriver = () => {
		if (!!deleteAdditionalDriver) {
			deleteAdditionalDriver(ind as number);
			setOpenDelDialog(false);

			resetCheckExistenceParamsOld();
		}
	}

	const handleCloseDeleteDialog = () => setOpenDelDialog(false);

	const handleOpenValidateDocumentsDialog = () => setOpenValidateDocumentsDialog(true);
	
	const handleCloseValidateDocumentsDialog = () => setOpenValidateDocumentsDialog(false);
	
	const handleConfirmValidateDocuments = () => {
		handleCloseValidateDocumentsDialog();
		validateDocuments?.(cbId, ind);
	}

	useEffect(() => {
		if(curReferenceProp === 'mainDriver') {
			setSource('raOwner');
		}
		else {
			setSource(ind === 0 ? 'firstDriver' : 'driver');
		}
	}, [])

	const checkDataIsEditable = (data: any) => {
		const disableResidenceAdressFields =
			(!!data?.residenceCity || !!data?.cityResidence) &&
			(!!data?.residenceProvince || !!data?.provinceResidence) &&
			(!!data?.residenceCountry || !!data.countryResidence) &&
			(!!data?.postcode || !!data?.postCode) &&
			!!data?.address &&
			!!data?.streetNumber;

		// build driver fields init state
		setInitDriverFieldsState({
			name: !!data?.name,
			surname: !!data?.surname,
			gender: !!data?.gender,
			fiscalCode: !!data?.fiscalCode,
			birthDate: !!data?.birthDate,
			birthPlace: !!data?.birthPlace,
			birthNation: !!data?.birthNation,
			citizenship: !!data?.citizenship,

			idNumber: !!data?.idNumber,
			idIssuingAuthority: !!data?.idIssuingAuthority,
			idIssueDate: !!data?.idIssueDate,
			idIssuingCountry: !!data?.idIssuingProvince,
			idIssuingProvince: !!data?.idIssuingProvince,
			idIssuingPlace: !!data?.idIssuingPlace,
			idExpiryDate: !!data?.idExpiryDate,

			addressGoogleSearch: disableResidenceAdressFields,
			residenceCountry: disableResidenceAdressFields,
			residenceProvince: disableResidenceAdressFields,
			residenceCity: disableResidenceAdressFields,
			postcode: disableResidenceAdressFields,
			address: disableResidenceAdressFields,
			streetNumber: disableResidenceAdressFields,

			prefix: !!data?.prefix,
			mobile: !!data?.mobile,
			email: !!data?.email,

			drivingLicenseNumber: !!data?.drivingLicenseNumber,
			drivingLicenseCategory: !!data?.drivingLicenseCategory,
			issuingAuthority: !!data?.issuingAuthority,
			issuingDate: !!data?.issuingDate,
			drivingLicenseIssuingCountry: !!data?.drivingLicenseIssuingProvince,
			drivingLicenseIssuingProvince: !!data?.drivingLicenseIssuingProvince,
			issuingPlace: !!data?.issuingPlace,
			drivingLicenseFirstReleaseDate: !!data?.drivingLicenseFirstReleaseDate,
			expireDate: !!data?.expireDate,

			idDocFront: !!data?.idDocFront,
			drivingLicenseDocFront: !!data?.drivingLicenseDocFront,
			idDocBack: !!data?.idDocBack,
			drivingLicenseDocBack: !!data?.drivingLicenseDocBack
		});
	}

	useEffect(() => {
		if (!!bookingDataValueFamily && source) {
			checkDataIsEditable(bookingDataValueFamily);
		}
	}, [bookingDataValueFamily, source]);

	/** Initial set state for enabled/disabled **/
	useEffect(() => {
		if (!_.isEmpty(bookingDataValueFamily)) {
			setCfValidated(bookingDataValueFamily?.cfValidated || null);
		}
	}, [bookingDataValueFamily])

	useEffect(() => {
		if (!isNaN(ind as number) && !!customerDataValue) {
			setNewAdded(!customerDataValue?.additionalDrivers[ind as number]?.cbId);
		}
	}, [customerDataValue])

	/** dep: birthPlace, set form value field of birth **/
	useEffect(() => {
		if (birthPlace) {
			const [country, locality, administrative_area_level_3] = getDataFromApiGoogle(birthPlace?.address_components, ['country', 'locality', 'administrative_area_level_3']);
			customerDataForm.setValue(`${curReferenceProp}.birthPlace`,  locality?.long_name ?? administrative_area_level_3?.long_name ?? '');
			const countriesCode = countriesList.map((elem: any) => elem.code);

			if(countriesCode.includes(country?.short_name)) {
				customerDataForm.setValue(`${curReferenceProp}.birthNation`,  {code: country.short_name, description: country.short_name});
				setBirthNationDisable(true);
				return;
			}

			customerDataForm.setValue(`${curReferenceProp}.birthNation`, {code: ADDITIONAL_DRIVER_INIT_VALUE.birthNation});
			setBirthNationDisable(false);
		}
	}, [birthPlace]);

	/** dep: residencePlace, set form value field of residence  **/
	useEffect(() => {
		if(residencePlace) {
			const filters = ['country', 'locality', 'route', 'street_number', 'postal_code', 'administrative_area_level_2', 'administrative_area_level_3'];
			const [country, locality, route, street_number, postal_code, administrative_area_level_2, administrative_area_level_3] = getDataFromApiGoogle(residencePlace?.address_components, filters);

			customerDataForm.setValue(`${curReferenceProp}.residenceCity`, locality?.long_name ?? administrative_area_level_3?.long_name ?? '');

			customerDataForm.setValue(`${curReferenceProp}.address`, route?.short_name ?? '');

			customerDataForm.setValue(`${curReferenceProp}.streetNumber`, street_number?.short_name ?? '' );

			if(!!route?.short_name) {
				customerDataForm.setValue(`${curReferenceProp}.addressGoogleSearch`, route?.short_name ?? '' );
			}

			customerDataForm.setValue(`${curReferenceProp}.postcode`, postal_code?.short_name ?? '' );

			const countriesCode = countriesList.map((elem: any) => elem.code);
			if(countriesCode.includes(country?.short_name)) {
				customerDataForm.setValue(`${curReferenceProp}.residenceCountry`,  {code: country.short_name, description: country.short_name});
				if(country.short_name === ITALY_CODE) {
					customerDataForm.setValue(`${curReferenceProp}.residenceProvince`, {codeProvince: administrative_area_level_2?.short_name, description: administrative_area_level_2?.short_name});
				} else {
					customerDataForm.setValue(`${curReferenceProp}.residenceProvince`,  ADDITIONAL_DRIVER_INIT_VALUE.residenceProvince);
				}
			} else {
				customerDataForm.setValue(`${curReferenceProp}.residenceCountry`, ADDITIONAL_DRIVER_INIT_VALUE.residenceCountry);
				customerDataForm.setValue(`${curReferenceProp}.residenceProvince`, ADDITIONAL_DRIVER_INIT_VALUE.residenceProvince);
			}
		}
	}, [residencePlace]);

	const [searchMessage, setSearchMessage] = useState<string>('');

	const [checkExistenceParamsOld, setCheckExistenceParamsOld] = useState({
        fiscalCode: '',
        drivingLicenseNumber: '',
        email: ''
    });

	const resetCheckExistenceParamsOld = () => setCheckExistenceParamsOld({fiscalCode: '', drivingLicenseNumber: '', email: ''});

	const findCustomerByUniqueDataQuery = useMutation({
        mutationFn: (queryBody: CustomerSearchFilters) => findCustomerBaseByUniqueData(queryBody),
        onSuccess: (resp: any) => {
            const respData: ICustomer[] = resp?.data;

			if (!!respData && respData.length > 0) {
				setCustomersFilter(null);

				setCustomerFinded(respData);

				setSearchDialogOpen(true);
            }
			else
				setSearchMessage('customerData.message.info.noUser');
        },
        onError: () => {

			dispatchGlobalData({
				type: setSnackbar,
				payload: {
					snackbar: {
						message: t('customerData.message.error.userSearch'),
						type: snackbarTypes.error,
						show: true,
						autoClose: true,
					}
				}
			})
        }
    });

	const handleCheckCustomerExistenceOnBlur = useCallback(async (label: string) => {

		if(!!searchMessage) setSearchMessage('');

		const { fiscalCode, residenceCountry , drivingLicenseNumber, email } = customerDataForm.getValues(`${curReferenceProp}`);

		if ((label == DriverCheckLabel.FISCAL_CODE && checkExistenceParamsOld.fiscalCode?.toUpperCase() == fiscalCode)
			|| (label == DriverCheckLabel.DRIVING_LICENCE && checkExistenceParamsOld.drivingLicenseNumber == drivingLicenseNumber)
			|| (label == DriverCheckLabel.EMAIL && checkExistenceParamsOld.email == email)
		) return;

		setCheckExistenceParamsOld({
			fiscalCode: fiscalCode?.toUpperCase() || '',
			drivingLicenseNumber: drivingLicenseNumber || '',
			email: email || ''
		});

		if(label == DriverCheckLabel.FISCAL_CODE && !!fiscalCode && genericValidate(DriverCheckLabel.FISCAL_CODE, fiscalCode, residenceCountry?.code)){
			findCustomerByUniqueDataQuery.mutate({taxCode: fiscalCode, partnerType: '1'});

		} else if(label == DriverCheckLabel.DRIVING_LICENCE && !!drivingLicenseNumber && genericValidate(DriverCheckLabel.DRIVING_LICENCE, drivingLicenseNumber, residenceCountry?.code)) {
			findCustomerByUniqueDataQuery.mutate({drvLicenceNumber: drivingLicenseNumber, partnerType: '1'});

		} else if(label == DriverCheckLabel.EMAIL && !!email && genericValidate(DriverCheckLabel.EMAIL, email)) {
			findCustomerByUniqueDataQuery.mutate({email: email, partnerType: '1'});
		}
	}, [searchMessage, customerDataForm, curReferenceProp, checkExistenceParamsOld]);

	useEffect(() => {
		dispatchGlobalData({
			type: setSnackbar,
			payload: {
				snackbar: {
					message: t('customerData.message.loading.searchingUser'),
					type: snackbarTypes.info,
					show: findCustomerByUniqueDataQuery.isLoading,
					autoClose: false,
				}
			}
		})
	}, [findCustomerByUniqueDataQuery.isLoading]);

	useEffect(() => {
		if(searchMessage !== ''){
			setTimeout(() => {
				dispatchGlobalData({
					type: setSnackbar,
					payload: {
						snackbar: {
							message: t(searchMessage),
							type: snackbarTypes.info,
							show: true,
							autoClose: true,
						}
					}
				})
			}, 500);
		}
	}, [searchMessage]);

	const [
		idIssuingCountry, idIssuingProvince, idIssuingPlace,
		drivingLicenseIssuingCountry, drivingLicenseIssuingProvince, drivingLicenseIssuingPlace,
	] = useWatch({
		name: [
			`${curReferenceProp}.idIssuingCountry`,
			`${curReferenceProp}.idIssuingProvince`,
			`${curReferenceProp}.idIssuingPlace`,
			`${curReferenceProp}.drivingLicenseIssuingCountry`,
			`${curReferenceProp}.drivingLicenseIssuingProvince`,
			`${curReferenceProp}.issuingPlace`,
		]
	})

	// useEffect(() => {
	// 	const FOREIGN_STATES = {
	// 		description: "Foreign States",
	// 		label: "Foreign States",
	// 		codeProvince: null
	// 	};

	// 	if (idIssuingCountry === 'IT') {
	// 		if (idIssuingProvince?.country !== 'IT') {
	// 			customerDataForm.setValue(`${curReferenceProp}.idIssuingProvince`, null);
	// 			// customerDataForm.setValue(`${curReferenceProp}.idIssuingPlace`, null);
	// 		}
	// 	} else if (idIssuingCountry === 'FR') {
	// 		if (idIssuingProvince?.country !== 'FR') {
	// 			customerDataForm.setValue(`${curReferenceProp}.idIssuingProvince`, null);
	// 		}
	// 		// customerDataForm.setValue(`${curReferenceProp}.idIssuingPlace`, idIssuingCountry);
	// 	} else {
	// 		customerDataForm.setValue(`${curReferenceProp}.idIssuingProvince`, FOREIGN_STATES);
	// 		// customerDataForm.setValue(`${curReferenceProp}.idIssuingPlace`, idIssuingCountry);
	// 	}

	// 	if (drivingLicenseIssuingCountry === 'IT') {
	// 		if (drivingLicenseIssuingProvince?.country !== 'IT') {
	// 			customerDataForm.setValue(`${curReferenceProp}.drivingLicenseIssuingProvince`, null);
	// 			// customerDataForm.setValue(`${curReferenceProp}.issuingPlace`, null);
	// 		}
	// 	} else if (drivingLicenseIssuingCountry === 'FR') {
	// 		if (drivingLicenseIssuingProvince?.country !== 'FR') {
	// 			customerDataForm.setValue(`${curReferenceProp}.drivingLicenseIssuingProvince`, null);
	// 		}
	// 		// customerDataForm.setValue(`${curReferenceProp}.issuingPlace`, drivingLicenseIssuingCountry);
	// 	} else {
	// 		customerDataForm.setValue(`${curReferenceProp}.drivingLicenseIssuingProvince`, FOREIGN_STATES);
	// 		// customerDataForm.setValue(`${curReferenceProp}.issuingPlace`, drivingLicenseIssuingCountry);
	// 	}
	// }, [
	// 	idIssuingCountry, idIssuingProvince?.codeProvince,
	// 	drivingLicenseIssuingCountry, drivingLicenseIssuingProvince?.codeProvince,
	// ]);

	return (
		<>
			<Accordion expanded={accordionState} onChange={(e, expanded) => handleAccordionOnChange(e, expanded)}>
				<AccordionSummary expandIcon={<ExpandMore />}>
					<HeaderDriverData
						title={title}
						cbId={cbId}
						verifiedDocuments={verifiedDocuments}
						handleClickSearch={handleClickSearch}
						handleClickClear={handleClickClear}
						handleClickReload={handleClickReload}
						handleDeleteAdditionalDriver={referenceProp !== 'mainDriver' ? handleDeleteAdditionalDriver : undefined}
						amountAdditionalDriverAncillary={referenceProp !== 'mainDriver' ? createRaPricingInfo?.amountTaxIncluded : undefined}
						currency={referenceProp !== 'mainDriver' ? createRaPricingInfo?.currency : undefined}
						disabled={keyLess || immutableRa || (bookingDataValue.bookingDetail.flagSubstitution && !newAdded)}
					/>
				</AccordionSummary>

				<AccordionDetails>
					<Grid container columnSpacing={2}>
						<Grid container item xs={12} md columnSpacing={2}>
							<Grid container item xs={12} gap={2}>
								<Typography variant="bodyLarge" sx={{marginTop: 4}}>
									{t("customerData.section.customerData")}
								</Typography>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.cbId`}
									label={t("customerData.form.label.customerID")}
									control={customerDataForm.control}
									fullWidth
									disabled
								/>
							</Grid>
							<Grid item xs={12} md={6} />
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.name`}
									control={customerDataForm.control}
									label={t("customerData.form.label.name")}
									fullWidth
									required
									//disabled={!!cfValidated || (!newAdded && initDriverFieldsState.name) || (bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.name)}
									disabled={keyLess || (!!cfValidated || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.name}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.surname`}
									control={customerDataForm.control}
									label={t("customerData.form.label.surname")}
									fullWidth
									required
									//disabled={!!cfValidated || (!newAdded && initDriverFieldsState.surname) || (bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.surname)}
									disabled={keyLess || (!!cfValidated || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.surname}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormAutocomplete<ICustomerDataForm>
									name={`${curReferenceProp}.gender`}
									label={t("customerData.form.label.gender")}
									control={customerDataForm.control}
									fullWidth
									options={GENDER_LIST}
									isOptionEqualToValue={(option, value) => option?.code === value?.code}
									getOptionLabel={(opt: any) => opt.code}
									required
									//disabled={!!cfValidated || (!newAdded && initDriverFieldsState.gender) || (bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.gender)}
									disabled={keyLess || (!!cfValidated || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.gender}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								{residenceCountry?.code === ITALY_CODE &&
									<FormTextField<ICustomerDataForm>
										name={`${curReferenceProp}.fiscalCode`}
										control={customerDataForm.control}
										label={t("customerData.form.label.fiscalCode")}
										fullWidth
										//disabled={!!cfValidated || (!newAdded && initDriverFieldsState.fiscalCode) || (bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.fiscalCode)}
										disabled={keyLess || (!!cfValidated || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.fiscalCode}
										inputProps={{ style: { textTransform: "uppercase"}}}
										InputProps={{endAdornment: EndAdornemnt}}
										onBlur={() => handleCheckCustomerExistenceOnBlur(DriverCheckLabel.FISCAL_CODE)}
									/>
								}
							</Grid>
							<Grid item xs={12} md={6}>
								<FormDatePicker<ICustomerDataForm>
									name={`${curReferenceProp}.birthDate`}
									control={customerDataForm.control}
									label={t("customerData.form.label.birthDate")}
									required
									//disabled={!!cfValidated || (!newAdded && initDriverFieldsState.birthDate) || (bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.birthDate)}
									disabled={keyLess || (!!cfValidated || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.birthDate}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<Controller
									name={`${curReferenceProp}.birthPlace`}
									control={customerDataForm.control}
									render={({field: {onChange, value}}: any) => (
										<GoogleAutocompleteWrapper
											googleInputProps={googleInputPropsBirthField}
											inputProps={{
												fullWidth: true,
												label: t("customerData.form.label.birthPlace"),
												id: 'birthPlace',
												name: `${curReferenceProp}.birthPlace`,
												type: 'text',
												value: value || '',
												//disabled: !!cfValidated || (!newAdded && initDriverFieldsState.birthPlace) || (bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.birthPlace),
												disabled: (keyLess || !!cfValidated || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.birthPlace,
												required: true,
												onChange: (e) => {
													onChange(e.target.value)
													if(!e.target.value) {handleResetBirthFields()}
												}
											}}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormAutocomplete<ICustomerDataForm>
									name={`${curReferenceProp}.birthNation`}
									label={t("customerData.form.label.birthNation")}
									control={customerDataForm.control}
									fullWidth
									options={countriesList}
									isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
									getOptionLabel={(opt: any) => t(countriesList.find((x: any) => x.code === opt.code)?.description)}
									required
									//disabled={(!!cfValidated && birthNationDisable) || (!newAdded && initDriverFieldsState.birthNation) || (bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.birthNation)}
									disabled={keyLess || ((!!cfValidated && birthNationDisable) || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.birthNation}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormAutocomplete<ICustomerDataForm>
									name={`${curReferenceProp}.citizenship`}
									label={t("customerData.form.label.citizenship")}
									options={commonPlacesQuery.data ?? []}
									required={!keyLess}
									getOptionLabel={(opt: any) => t(`countries.${opt.code}`)}
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.citizenship) || (!newAdded && initDriverFieldsState.citizenship)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.citizenship}
								/>
							</Grid>
							<Grid container item xs={12}>
								<Typography variant="bodyLarge" sx={{marginTop: 4}}>
									{t('customerData.section.identityCard')}
								</Typography>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.idNumber`}
									control={customerDataForm.control}
									label={t("customerData.form.label.idNumber")}
									required={!!idDocFront && !!idDocBack}
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.idNumber) || (!newAdded && initDriverFieldsState.idNumber)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.idNumber}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.idIssuingAuthority`}
									control={customerDataForm.control}
									label={t("customerData.form.label.idIssuingAuthority")}
									required={!!idDocFront && !!idDocBack}
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.idIssuingAuthority) || (!newAdded && initDriverFieldsState.idIssuingAuthority)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.idIssuingAuthority}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormDatePicker<ICustomerDataForm>
									name={`${curReferenceProp}.idIssueDate`}
									control={customerDataForm.control}
									label={t("customerData.form.label.idIssueDate")}
									required={!!idDocFront && !!idDocBack}
									disableFuture
									onChange={handleChangeIdIssueDate}
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.idIssueDate) || (!newAdded && initDriverFieldsState.idIssueDate)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.idIssueDate}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormAutocomplete<ICustomerDataForm>
									name={`${curReferenceProp}.idIssuingCountry`}
									label={t("customerData.form.label.idIssuingCountry")}
									options={countriesList?.map((c: any) => c.code).sort()}
									control={customerDataForm.control}
									fullWidth
									required
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.idIssuingProvince}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<IdIssuingProvinceField referenceProp={curReferenceProp}
														//disabled={bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.idIssuingProvince}
														disabled={!["FR","IT"].includes(idIssuingCountry) || keyLess || (bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.idIssuingProvince}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<IdIssuingPlaceField referenceProp={curReferenceProp}
													 disabled={(idIssuingCountry === 'IT' && !idIssuingProvince) || idIssuingCountry !== 'IT' || keyLess || bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.idIssuingPlace}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormDatePicker<ICustomerDataForm>
									name={`${curReferenceProp}.idExpiryDate`}
									control={customerDataForm.control}
									label={t("customerData.form.label.idExpiryDate")}
									required={!!idDocFront && !!idDocBack}
									disablePast
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.idExpiryDate) || (!newAdded && initDriverFieldsState.idExpiryDate)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.idExpiryDate}
								/>
							</Grid>
						</Grid>

						<Grid container item xs={12} md columnSpacing={2}>
							<Grid container item xs={12}>
								<Typography variant="bodyLarge" sx={{marginTop: 4}}>
									{t('customerData.section.residenceContacts')}
								</Typography>
							</Grid>
							<Grid item xs={11} sm={11}>
								<Controller
									name={`${curReferenceProp}.addressGoogleSearch`}
									control={customerDataForm.control}
									render={({field: {onChange, value}}: any) => (
										<GoogleAutocompleteWrapper
											googleInputProps={googleInputPropsResidenceField}
											inputProps={{
												fullWidth: true,
												label: t('customerData.form.label.googleFilterAddress'),
												id: 'addressGoogleSearch',
												name: `${curReferenceProp}.addressGoogleSearch`,
												type: 'text',
												value: value || '',
												//disabled: immutableRa || (!newAdded && initDriverFieldsState.addressGoogleSearch) ||
												//	(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.addressGoogleSearch),
												disabled: keyLess || (immutableRa || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.addressGoogleSearch,
												onChange: (e) => {
													onChange(e.target.value)
													if(!e.target.value) {handleResetResidenceAddressFields()}
												}
											}}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={1} sm={1} alignItems="center"
								  sx={{textAlign: 'center', marginTop: 'auto'}}>
								<Tooltip arrow placement="top" title={t("customerData.button.resetResidenceValue")}>
									<IconButton onClick={handleResetResidenceAddressFields}
												//disabled={immutableRa || (!newAdded && initDriverFieldsState.addressGoogleSearch) ||
												//	(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.addressGoogleSearch)}
                                                disabled={keyLess || (immutableRa || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.addressGoogleSearch}
									>
										<DeleteRounded fontSize="small" />
									</IconButton>
								</Tooltip>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormAutocomplete<ICustomerDataForm>
									name={`${curReferenceProp}.residenceCountry`}
									label={t("customerData.form.label.residenceCountry")}
									options={countriesList}
									control={customerDataForm.control}
									fullWidth
									isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
									getOptionLabel={(opt: any) => opt.code}
									required
									//disabled={immutableRa || (!newAdded && initDriverFieldsState.residenceCountry) ||
									//	(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.residenceCountry)}
									disabled={keyLess || (immutableRa || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.residenceCountry}
									onChange={handleResidenceCountryChange}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormAutocomplete<ICustomerDataForm>
									name={`${curReferenceProp}.residenceProvince`}
									label={t("customerData.form.label.residenceProvince")}
									options={provincesQuery.data?.response ?? []}
									loading={provincesQuery.isInitialLoading}
									control={customerDataForm.control}
									fullWidth
									isOptionEqualToValue={(option: any, value: any) => option?.codeProvince === value?.codeProvince}
									getOptionLabel={(opt: any) => opt.description}
									required={residenceCountry?.code === ITALY_CODE}
									//disabled={immutableRa || (!newAdded && initDriverFieldsState.residenceProvince) ||
									//	(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.residenceProvince)}
                                    disabled={keyLess || (immutableRa || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.residenceProvince}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.residenceCity`}
									label={t("customerData.form.label.residenceCity")}
									control={customerDataForm.control}
									fullWidth
									required
									//disabled={immutableRa || (!newAdded && initDriverFieldsState.residenceCity) ||
									//	(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.residenceCity)}
									disabled={keyLess || (immutableRa || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.residenceCity}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.postcode`}
									label={t("customerData.form.label.postcode")}
									control={customerDataForm.control}
									fullWidth
									required
									//disabled={immutableRa || (!newAdded && initDriverFieldsState.postcode) ||
									//	(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.postcode)}
									disabled={keyLess || (immutableRa || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.postcode}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.address`}
									label={t("customerData.form.label.address")}
									control={customerDataForm.control}
									fullWidth
									required
									//disabled={immutableRa || (!newAdded && initDriverFieldsState.address) ||
									//	(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.address)}
									disabled={keyLess || (immutableRa || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.address}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.streetNumber`}
									label={t("customerData.form.label.streetNumber")}
									control={customerDataForm.control}
									fullWidth
									required
									//disabled={immutableRa || (!newAdded && initDriverFieldsState.streetNumber) ||
									//	(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.streetNumber)}
                                    disabled={keyLess || (immutableRa || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.streetNumber}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.email`}
									label={t("customerData.form.label.email")}
									control={customerDataForm.control}
									fullWidth
									required
									//disabled={!!uuid || (!newAdded && initDriverFieldsState.email) ||
									//    (bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.email)}
									disabled={keyLess || (!!uuid || newAdded || bookingDataValue.bookingDetail.flagSubstitution) && initDriverFieldsState.email}
                                    onBlur={() => handleCheckCustomerExistenceOnBlur(DriverCheckLabel.EMAIL)}
								/>
							</Grid>
							<Grid item xs={6} md={3}>
								<FormAutocomplete<ICustomerDataForm>
									name={`${curReferenceProp}.prefix`}
									label={t("customerData.form.label.prefix")}
									options={prefixesList}
									control={customerDataForm.control}
									fullWidth
									isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
									getOptionLabel={(opt: any) => `+${opt?.description} (${opt?.code})`}
									required
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.prefix) ||
									//            (!newAdded && initDriverFieldsState.prefix)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.prefix}
								/>
							</Grid>
							<Grid item xs={6} md={3}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.mobile`}
									label={t("customerData.form.label.phone")}
									control={customerDataForm.control}
									fullWidth
									required
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.mobile) ||
									//                (!newAdded && initDriverFieldsState.mobile)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.mobile}
								/>
							</Grid>
							<Grid container item xs={12}>
								<Typography variant="bodyLarge" sx={{marginTop: 4}}>
									{t('customerData.section.drivingLicense')}
								</Typography>
							</Grid>
							<Grid item xs={6} md={3}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.drivingLicenseNumber`}
									label={t("customerData.form.label.drivingLicenseNumber")}
									control={customerDataForm.control}
									fullWidth
									required
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.drivingLicenseNumber) ||
									//        (!newAdded && initDriverFieldsState.drivingLicenseNumber)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.drivingLicenseNumber}
                                    onBlur={() => handleCheckCustomerExistenceOnBlur(DriverCheckLabel.DRIVING_LICENCE)}
								/>
							</Grid>
							<Grid item xs={6} md={3}>
								<FormAutocomplete<ICustomerDataForm>
									name={`${curReferenceProp}.drivingLicenseCategory`}
									label={t("customerData.form.label.drivingLicenseCategory")}
									options={DRIVER_LICENCE_CATEGORY_LIST}
									control={customerDataForm.control}
									fullWidth
									getOptionLabel={(option) => option ? t(option) : ''}
									required
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.drivingLicenseCategory) ||
									//            (!newAdded && initDriverFieldsState.drivingLicenseCategory)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.drivingLicenseCategory}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormTextField<ICustomerDataForm>
									name={`${curReferenceProp}.issuingAuthority`}
									label={t("customerData.form.label.issuingAuthority")}
									control={customerDataForm.control}
									fullWidth
									required
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.issuingAuthority) ||
									//            (!newAdded && initDriverFieldsState.issuingAuthority)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.issuingAuthority}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormDatePicker<ICustomerDataForm>
									name={`${curReferenceProp}.issuingDate`}
									label={t("customerData.form.label.issuingDate")}
									control={customerDataForm.control}
									required
									disableFuture
									onChange={handleChangeDrivingLicenseIssueDate}
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.issuingDate) ||
									//            (!newAdded && initDriverFieldsState.issuingDate)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.issuingDate}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormAutocomplete<ICustomerDataForm>
									name={`${curReferenceProp}.drivingLicenseIssuingCountry`}
									label={t("customerData.form.label.drivingLicenseIssuingCountry")}
									options={countriesList?.map((c: any) => c.code).sort()}
									control={customerDataForm.control}
									fullWidth
									required
									disabled={keyLess || bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.drivingLicenseIssuingProvince}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<DrivingLicenseIssuingProvinceField referenceProp={curReferenceProp}
																	//disabled={bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.drivingLicenseIssuingProvince}
																	disabled={!["FR", "IT"].includes(drivingLicenseIssuingCountry) || keyLess || bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.drivingLicenseIssuingProvince}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<DrivingLicenseIssuingPlaceField referenceProp={curReferenceProp}
																 //disabled={bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.issuingPlace}
																 disabled={(drivingLicenseIssuingCountry === 'IT' && !drivingLicenseIssuingProvince) || drivingLicenseIssuingCountry !== 'IT' || keyLess || bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.issuingPlace}
																 required={!keyLess}
							    />
							</Grid>
							<Grid item xs={12} md={6}>
								<FormDatePicker<ICustomerDataForm>
									name={`${curReferenceProp}.drivingLicenseFirstReleaseDate`}
									label={t("customerData.form.label.drivingLicenseFirstReleaseDate")}
									control={customerDataForm.control}
									required
									disableFuture
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.drivingLicenseFirstReleaseDate) ||
									//            (!newAdded && initDriverFieldsState.drivingLicenseFirstReleaseDate)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.drivingLicenseFirstReleaseDate}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<FormDatePicker<ICustomerDataForm>
									name={`${curReferenceProp}.expireDate`}
									label={t("customerData.form.label.expireDate")}
									control={customerDataForm.control}
									required
									//disablePast
									minDate={recoveryMode && !!recoveryRaInfo?.effectivePickupDate ?  recoveryRaInfo.effectivePickupDate : dayjs()}
									//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.expireDate) ||
									//            (!newAdded && initDriverFieldsState.expireDate)}
									disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.expireDate }
								/>
							</Grid>
						</Grid>

						<Grid container item xs={12} columnSpacing={2} rowSpacing={2} mt={2}>
							<UploadDocument
								currentDocument={idDocFront}
								required={residenceCountry?.code !== ITALY_CODE}
								curReferenceProp={referenceProp}
								ind={ind}
								name="idDocFront"
								title={t('customerData.form.label.idFrontUpload')}
								//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.idDocFront) ||
								//    (!newAdded && initDriverFieldsState.idDocFront)}
								disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.idDocFront}
							/>
							<UploadDocument
								currentDocument={drivingLicenseDocFront}
								required
								curReferenceProp={referenceProp}
								ind={ind}
								name="drivingLicenseDocFront"
								title={t('customerData.form.label.drivingLicenseFrontUpload')}
								//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.drivingLicenseDocFront) ||
								//        (!newAdded && initDriverFieldsState.drivingLicenseDocFront)}
								disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.drivingLicenseDocFront}
							/>
							<UploadDocument
								currentDocument={idDocBack}
								required={residenceCountry?.code !== ITALY_CODE}
								curReferenceProp={referenceProp}
								ind={ind}
								name="idDocBack"
								title={t('customerData.form.label.idBackUpload')}
								//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.idDocBack) ||
								//            (!newAdded && initDriverFieldsState.idDocBack)}
								disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.idDocBack}
							/>
							<UploadDocument
								currentDocument={drivingLicenseDocBack}
								required
								curReferenceProp={referenceProp}
								ind={ind}
								name="drivingLicenseDocBack"
								title={t('customerData.form.label.drivingLicenseBackUpload')}
								//disabled={(bookingDataValue.bookingDetail.flagSubstitution && initDriverFieldsState.drivingLicenseDocBack) ||
								//        (!newAdded && initDriverFieldsState.drivingLicenseDocBack)}
								disabled={keyLess || (bookingDataValue.bookingDetail.flagSubstitution || newAdded) && initDriverFieldsState.drivingLicenseDocBack}
							/>
						</Grid>	
					</Grid>

					{!!cbId && (verifiedDocuments !== null) && (verifiedDocuments !== undefined) &&
						<Box pt={2} display={"flex"} justifyContent={"center"}>
							<Button 
								color="accent" 
								onClick={handleOpenValidateDocumentsDialog}
								disabled={/*keyLess || */ verifiedDocuments /*|| !drivingLicenseDocFront || !drivingLicenseDocBack*/}
							>
									{t("customerData.button.validateDocuments")}
							</Button>
						</Box>
					}
				</AccordionDetails>
			</Accordion>
			<SearchCustomerDialog
				type={BILLING_OWNER_TYPE.PERSON}
				open={searchDialogOpen}
				onClose={handleCloseSearchDialog}
				onCustomerSelected={handleCustomerSelected}
				customersFilter={customersFilter}
				customerList={customerFinded}
			/>

			<Dialog
				open={openDelDialog}
				onClose={handleCloseDeleteDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{t("customerData.dialog.deleteDriver.header")}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{t("customerData.dialog.deleteDriver.content")}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button variant={"outlined"} color={'secondary'} onClick={handleCloseDeleteDialog}>
						{t('customerData.dialog.deleteDriver.action.cancel')}
					</Button>
					<Button onClick={deleteDriver}>
						{t('customerData.dialog.deleteDriver.action.confirm')}
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={openValidateDocumentsDialog}
				onClose={handleCloseValidateDocumentsDialog}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{t("customerData.dialog.validateDocuments.header")}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description" whiteSpace={"break-spaces"}>
						{t("customerData.dialog.validateDocuments.content")}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button variant={"outlined"} color={'secondary'} onClick={handleCloseValidateDocumentsDialog}>
						{t('customerData.dialog.validateDocuments.action.cancel')}
					</Button>
					<Button onClick={handleConfirmValidateDocuments}>
						{t('customerData.dialog.validateDocuments.action.confirm')}
					</Button>
				</DialogActions>
			</Dialog>
			<CustomLoader loading={findCustomerByUniqueDataQuery.isLoading}/>
		</>
	);
}

export default DriverData
